
import Api from "@/services/Api";
import { defineComponent, Ref, ref, onMounted, watch, defineModel } from "vue";
import type { PropType } from "vue";
import * as yup from "yup";
import useAlert from '@/composables/Alert'
import useEmitter from "@/composables/Emmiter";
import Button from "@/components/Button.vue"
import { error } from "console";



export default defineComponent({
  name: "ModalUsers",
  components: {
    Button,
  },
  props: {
    usuario: Object as PropType<any>,
    fechaModal: Function,
    abreModal: Function,
  },

  setup(props) {

    const { showTimeAlert } = useAlert()
    const emitter = useEmitter()

    const usuario: Ref<any> = ref({});
    const arrayLojas: Ref<any[]> = ref([]);
    const usuarioLojas: Ref<any> = ref([]);

    const loadSave: Ref<boolean> = ref(false);
    const loadExcluir: Ref<boolean> = ref(false);
    const loadRemoveUsuario: Ref<boolean> = ref(false);
    const loadResetarSenha: Ref<boolean> = ref(false);
    const dialogVisible: Ref<boolean> = ref(false);

    const clikouResetarSenha: Ref<boolean> = ref(false);
    const novaSenha: Ref<string> = ref('indicar');


    const inputComMascara: Ref<string> = ref('');
    const adicionarUsuarioEmNovaLoja: Ref<boolean> = ref(false)

    const arrayCargos: Ref<any[]> = ref([]);
    const idLoja: Ref<any> = ref(null);



    // ---------------------------------
    function formatarInput(type: string, event) {

      if (type === 'documento') {
        inputComMascara.value = event.replace(/\D/g, "");
        inputComMascara.value = inputComMascara.value.replace(/(\d{3})(\d)/, "$1.$2");
        inputComMascara.value = inputComMascara.value.replace(/(\d{3})(\d)/, "$1.$2");
        inputComMascara.value = inputComMascara.value.replace(/(\d{3})(\d{1,2})$/, "$1-$2");

        usuario.value.documento = inputComMascara.value;
      }

      if (type === 'telefone') {
        inputComMascara.value = event.replace(/\D/g, "");
        inputComMascara.value = inputComMascara.value.replace(/^(\d\d)(\d)/g, "($1) $2");
        inputComMascara.value = inputComMascara.value.replace(/(\d{5})(\d)/, "$1-$2");

        usuario.value.telefone = inputComMascara.value;
      }

      return ''

    }
    // ---------------------------------

    function fechaModal(){

      props.fechaModal && props.fechaModal()

    }

    function abreModal(){

      usuario.value = { ...props.usuario } 
      clikouResetarSenha.value = false
      getLojasUsuario()

    }

    function enviaUsuarioAtualizado(usuarioParam) {
      emitter.emit('enviaUsuarioAtualizado', { usuario: usuarioParam })
    }

    function removeUsuarioLista(usuarioParam) {
      emitter.emit('removeUsuarioLista', { usuario: usuarioParam })
    }

    function validaEmail(email){
      const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if(email == undefined || email == null){
        showTimeAlert('O campo Email é obrigatório', 'error');
      } else if(!regexEmail.test(email)) {
        showTimeAlert('Por favor, insira um email válido.', 'error');
      } else {
        return true;
      }
    }

    //     FUNÇÕES PRINCIPAIS     //
    // 
    //      ||            ||      //
    //      ||            ||      //
    //      ||            ||      //
    //      ||            ||      //
    //     \  /          \  /     //
    //      \/            \/      //


    async function resetarSenha() { 

      loadResetarSenha.value = true

      const { data } = await Api.post("resetarSenha", { usuario: usuario.value, novaSenha: novaSenha.value })

      loadResetarSenha.value = false

      if(!data.usuario) return showTimeAlert(data?.message, "error")

      novaSenha.value = ""

      return showTimeAlert('Senha resetada com sucesso!', "success")
      
    }

    async function deletarUsuario() { 

      loadExcluir.value = true

      const { data } = await Api.delete("deletaUsuario", { id: usuario.value.id, nivel: usuario.value.nivel })

      loadExcluir.value = false

      if(!data.usuario) return showTimeAlert(data?.message, "error")

      removeUsuarioLista(data.usuario)

      dialogVisible.value = false;
      fechaModal()

      return showTimeAlert('usuário deletado com sucesso!', "success")
      
    }

    async function salvaUsuario() {
      loadSave.value = true
      
      if(validaEmail(usuario.value.email)) {
        try {
          
          const { data } = await Api.post("salvaUsuario", { usuario: usuario.value, arrayIdLoja: [...usuarioLojas.value, idLoja.value] });
          if (!data.usuario) {
            console.error(data.erro)
            return showTimeAlert(data?.message, "error");
          }
          enviaUsuarioAtualizado(data.usuario)
  
          fechaModal()
  
          return showTimeAlert('usuário salvo com sucesso!', "success")
        } catch (error) {
          showTimeAlert('erro ao salvar usuário', "error");
          console.log(error)
        } finally {
          loadSave.value = false
  
        }
      }
      loadSave.value = false
    }

    async function getLojas() {

      const res = await Api.get("getAllStores");

      arrayLojas.value = res.data.lojas;

    }

    async function getCargo() {

      arrayCargos.value = (await Api.get('getCargosUsuario') as any).data.cargos || []

    }

    
    async function getLojasUsuario(){

      const { data } = await Api.get('buscaLojasUsuario', {idUsuario: usuario.value.id})

      usuarioLojas.value = data.lojas.map(({id})=>id)

    }

    async function removeLojaUsuario() {

      loadRemoveUsuario.value = true

      const { data } = await Api.post("removeLojaUsuario", { idUsuario: usuario.value.id, arrayIdLoja: [idLoja.value] })

      loadRemoveUsuario.value = false

      if(!data.usuario) return showTimeAlert(data.message, "error");
      
      showTimeAlert('usuário removido com sucesso!', "success");

      removeUsuarioLista(data.usuario)

      dialogVisible.value = false;
      fechaModal()

    }
    
    emitter.on("idLojaUser", async params => {
       idLoja.value = params.idLoja;
    });


    // abrindo modal com usuario
    watch(() => props.usuario, async () => { abreModal() }, { deep: true })

    onMounted(async()=>{
      getCargo()
      getLojas()
    })
   
    return {
      usuario,
      fechaModal,
      deletarUsuario,
      salvaUsuario,
      resetarSenha,
      formatarInput,
      loadSave,
      loadRemoveUsuario,
      arrayCargos,
      loadExcluir,
      arrayLojas,
      adicionarUsuarioEmNovaLoja,
      clikouResetarSenha,
      novaSenha,
      loadResetarSenha,
      usuarioLojas,
      idLoja,
      removeLojaUsuario,
      dialogVisible
    };
  },
});
